<template>
  <div
    v-if="galleryItems.length"
    class="media-gallery"
  >
    <div
      v-show="isDesktop === null || isDesktop"
      class="media-gallery__desktop-only"
    >
      <UiMediaGalleryDesktopMain class="media-gallery__desktop" />
    </div>
    <div
      v-show="isDesktop === null || !isDesktop"
      class="media-gallery__mobile-only"
    >
      <div class="media-gallery__container">
        <UiMediaGalleryMain class="media-gallery__main" />

        <template v-if="!thumbsAreDots">
          <UiMediaGalleryThumbs class="media-gallery__thumbs" />
        </template>
        <template v-else>
          <UiMediaGalleryDots class="media-gallery__dots" />
        </template>

        <UiMediaGalleryXofY class="media-gallery__x-of-y" />
        <slot />
      </div>

      <UiMediaGalleryFullscreen />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Item } from '~layers/app/composables/useUiMediaGallery'

const props = defineProps({
  media: {
    type: Array as PropType<Item[]>,
    default: () => [],
  },
})

const { galleryItems, thumbsAreDots } = useUiMediaGallery({
  media: props.media,
  index: 1,
})

// const { isOpen: isFullscreen } = useUiDialog('media-gallery')
const isDesktop = ref(null)

onBeforeMount(() => {
  isDesktop.value = ref(useMediaQuery('(min-width: 1024px)')).value
  useEventListener(window, 'resize', () => {
    isDesktop.value = ref(useMediaQuery('(min-width: 1024px)')).value
  })
})

onUnmounted(() => {
  // isFullscreen.value = false
})
</script>

<style>
 @import url("~layers/app/components/Ui/MediaGallery/index.css");
</style>
